import { Skeleton, Card, CardContent, CardOverflow, AspectRatio, Stack } from '@mui/joy';
import { useTheme, useMediaQuery } from '@mui/material';
import { RecipeGrid } from './RecipeGrid';

export function RecipesSkeleton() {
  const dummyRecipes = Array.from({ length: 16 }).map((_, index) => ({ id: index }));
  return (
    <RecipeGrid recipes={dummyRecipes} card={() => <RecipeCardSkeleton />} />
  );
}

function RecipeCardSkeleton() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const ratio = isXs ? 6 / 4 : 8 / 4;

  return (
    <Card variant="outlined" sx={{
      width: '100%',
      flex: 1,
      border: 'none',
      overflow: 'hidden',
      boxShadow: 'var(--joy-shadow-sm)',
      gap: 0,
    }} size="md">
      <CardOverflow>
        <AspectRatio ratio={ratio}>
          <Skeleton variant="overlay" />
        </AspectRatio>
      </CardOverflow>
      <CardContent sx={{
        minWidth: 0,
        flex: 1,
        marginInline: 'calc(-1 * var(--Card-padding))',
        marginBottom: 'calc(-1 * var(--Card-padding))',
        padding: '10px 12px',
        gap: '4px',
      }}>
        <Skeleton variant="text" level="title-md" width="70%" />
        <Stack direction="row" gap={1} sx={{ mt: '4px' }}>
          <Skeleton variant="text" level="title-xs" width="35%" />
        </Stack>
      </CardContent>
    </Card>
  );
}
